import { LegalLayout } from './LegalLayout';
import { BOOK_AUTHOR, SITE_URL } from '../../lib/constants';

export function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" lastUpdated="April 30, 2026">
      <p>
        This Privacy Policy describes how {BOOK_AUTHOR} ("we", "us") collects, uses,
        and shares information when you visit{' '}
        <a href={SITE_URL}>{SITE_URL.replace('https://', '')}</a> (the "Site").
      </p>

      <h2>Information we collect</h2>
      <p>
        <strong>Information you provide.</strong> When you sign up for the newsletter,
        you provide your email address. When you contact support, we receive your
        email and the content of your message.
      </p>
      <p>
        <strong>Automatically collected information.</strong> We use Google Analytics
        4 to understand how visitors interact with the Site. Analytics cookies are
        only set if you accept them via our cookie banner; we operate Google's
        Consent Mode and analytics storage is denied by default. Analytics data may
        include pages viewed, approximate location (city/region), device type, and
        referrer.
      </p>
      <p>
        <strong>Server logs.</strong> Our hosting provider records standard request
        logs (IP address, user agent, timestamp) for security and operational
        purposes. For our game leaderboard, IP addresses are one-way hashed before
        storage and never written in raw form.
      </p>

      <h2>How we use information</h2>
      <ul>
        <li>To deliver content you request, including newsletters you opt into.</li>
        <li>To respond to support inquiries.</li>
        <li>To detect abuse and protect the Site.</li>
        <li>To understand aggregate traffic patterns and improve the Site.</li>
      </ul>

      <h2>Third parties</h2>
      <p>
        We rely on a small number of service providers, each of whom acts on our
        behalf and is bound by their own privacy commitments:
      </p>
      <ul>
        <li>
          <strong>Amazon (Kindle / KDP).</strong> Purchases of the eBook and
          paperback are completed on Amazon. Amazon's privacy policy governs that
          transaction; we do not receive your payment information.
        </li>
        <li>
          <strong>Google Analytics.</strong> Aggregated analytics, only when you
          have accepted cookies.
        </li>
        <li>
          <strong>Resend.</strong> Transactional and newsletter email delivery.
        </li>
        <li>
          <strong>Linode / Akamai.</strong> Hosting infrastructure.
        </li>
      </ul>

      <h2>Cookies</h2>
      <p>
        We use a small set of cookies. A first-party cookie stores your consent
        choice. If you accept analytics, Google Analytics sets its own cookies. If
        you sign in to the admin area, we set a session cookie. We do not use
        cookies for advertising and we do not sell or share your data with third
        parties for cross-context behavioral advertising.
      </p>

      <h2>Your choices</h2>
      <ul>
        <li>You may decline analytics cookies via the cookie banner at any time by clearing site data.</li>
        <li>You may unsubscribe from the newsletter using the link in any email we send.</li>
        <li>
          Depending on where you live, you may have rights to access, correct, or
          delete your personal information. To exercise these rights, email{' '}
          <a href="mailto:support@moneyskillsbook.com">support@moneyskillsbook.com</a>.
        </li>
      </ul>

      <h2>Children</h2>
      <p>
        The Site is not directed to children under 13, and we do not knowingly
        collect personal information from children.
      </p>

      <h2>Changes to this policy</h2>
      <p>
        We may update this policy from time to time. The "Last updated" date at the
        top of this page reflects the most recent revision.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about this policy?{' '}
        <a href="mailto:support@moneyskillsbook.com">support@moneyskillsbook.com</a>.
      </p>
    </LegalLayout>
  );
}
